import { useEffect, useRef, useState } from "react";

export default function HeroSection() {
  const [loaded, setLoaded] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const handleContactClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const el = document.querySelector("#contact");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      ref={ref}
      className="relative w-full min-h-[100dvh] flex items-end overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/b101d8e3-eb8f-4b23-a967-4f4a49b8c766/4cb340a6-58b7-492c-8666-d84847ba489d_scenery.png?v=1f8215f477d3acf19dbf686edcce640d"
          alt="静岡県東伊豆町稲取の海を望む温泉民宿宝栄丸"
          width={1920}
          height={1080}
          fetchPriority="high"
          decoding="async"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Overlay gradient */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-black/10" />

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-12 lg:px-20 pb-24 md:pb-32 lg:pb-36">
        <div
          className={`max-w-3xl transition-all duration-1000 ${
            loaded
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-8"
          }`}
        >
          <p className="text-white/70 text-xs md:text-sm tracking-[0.3em] mb-4 md:mb-6">
            静岡県東伊豆町稲取
          </p>
          <h1 className="font-serif text-white leading-[1.1] mb-6 md:mb-8">
            <span className="block text-3xl md:text-5xl lg:text-6xl font-light">
              稲取の海を眺める
            </span>
            <span className="block text-4xl md:text-6xl lg:text-7xl font-medium mt-2 md:mt-3">
              湯の宿
            </span>
            <span className="block text-5xl md:text-7xl lg:text-8xl font-semibold mt-2 md:mt-3 tracking-wider">
              宝栄丸
            </span>
          </h1>
          <a
            href="#contact"
            onClick={handleContactClick}
            className="inline-flex items-center gap-3 px-8 py-4 bg-white text-stone-900 text-sm md:text-base rounded-full hover:bg-white/90 transition-all whitespace-nowrap group"
          >
            <i className="ri-calendar-check-line" />
            空室確認・ご予約
            <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-3 md:bottom-4 left-1/2 -translate-x-1/2 z-10">
        <div className="flex flex-col items-center gap-1.5">
          <span className="text-white/60 text-[10px] tracking-widest">
            SCROLL
          </span>
          <div className="w-px h-8 bg-white/40 relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1/2 bg-white animate-bounce" />
          </div>
        </div>
      </div>
    </section>
  );
}